import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { PayoutStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('payout', reducer),
        EffectsModule.forFeature([PayoutStoreEffects])
    ],
    providers: []
})
export class PayoutStoreModule {}
